<template>
  <div class="replace">
    <div class="section">
      <div class="title">{{ $t('product.replaceGuide') }}</div>
      <div class="content">
        {{ $t('product.replaceGuideDesc') }}<br>
        <span v-html="$t('product.replaceGuideDesc2')"></span>
      </div>
    </div>
    <div class="section">
      <div class="title">
        {{ $t('product.replaceMaterial') }}
      </div>
      <div class="material-list">
        <div class="material-item" v-for="(item,index) in materialList" :key="item.title">
          <div class="material-title"> <img :src="item.icon" alt=""> {{ $t(item.title )}}</div>
          <div class="material-desc">{{ $t(item.desc) }}</div>
          <div @click="handleClick(index)"  class="material-btn" :class="{'btn-white':item.btnColor === 'white'}">
            <div  class="btn-text">{{ $t(item.btnText) }}</div>
            <img :src="item.btnIcon" alt="">
          </div>
        </div>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <VideoPop
      :visible="videoVisible"
      :video-src="videoSrc"
      :title="videoTitle"
      @close="videoVisible = false"
    />
  </div>
</template>

<script>
import VideoPop from '@/components/VideoPop.vue';

export default {
  components: {
    VideoPop
  },
  props: {
    productInfo: {
      type: Object,
      default: () => {},
    },
    productType: {
      type: String,
      default: '',
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    videoSrc() {
      return `/videos/replace/${this.lang}/${this.productType}_${this.productInfo.id}.mp4?v=${this.version}`;
    },
    videoTitle() {
      return `POP${this.productType} ${this.productInfo.title} - ${this.$t('product.replaceVideo')}`;
    },
  },
  data() {
    return {
      videoVisible: false,
      materialList: [
        {
          icon: require('@/assets/icons/VideoCamera.svg'),
          title: 'product.replaceVideo',
          desc: 'product.replaceVideoDesc',
          btnText: 'product.replaceVideoBtn',
          btnIcon: require('@/assets/icons/play.svg')
        },
        {
          icon: require('@/assets/icons/Read.svg'),
          title: 'product.replaceManual',
          desc: 'product.replaceManualDesc',
          btnText: 'product.replaceManualBtn',
          btnIcon: require('@/assets/icons/Download.svg'),
          btnColor:'white'
        },
        {
          icon: require('@/assets/icons/Picture.svg'),
          title: 'product.replaceManualImg',
          desc: 'product.replaceManualImgDesc',
          btnText: 'product.replaceManualImgBtn',
          btnIcon: require('@/assets/icons/ExpandAlt.svg'),
          btnColor:'white'
        },
      ],
      version: process.env.VUE_APP_VERSION || Date.now(), // 静态资源版本号
    };
  },
  methods: {
    handleClick(index) {
      if (index === 0) {
        // 打开视频弹窗
        this.videoVisible = true;
      } else if (index === 1) {
        let manualUrl = `/pdfs/replace/${this.lang}/${this.productType}_${this.productInfo.id}.pdf?v=${this.version}`
        let name = `${this.productType}_${this.productInfo.id}.pdf`;
        let xhr = new XMLHttpRequest();
        xhr.open('GET', manualUrl, true);
        xhr.responseType = 'blob';
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let blob = new Blob([xhr.response], { type: 'application/pdf' });
            let url = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = name;
            a.click();
            URL.revokeObjectURL(url);
          }
        };
        xhr.send();
      } else if (index === 2) {
        window.open(`/pdfs/replace/${this.lang}/${this.productType}_${this.productInfo.id}.pdf?v=${this.version}`, '_blank');
      }
    }
  }
}
</script>

<style lang='scss' scoped>

</style>